module.exports = __webpack_public_path__ + "static/media/cloud-upload.5179df7e.svg";